var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowWidthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14814 6.68514C6.50612 7.04312 6.50612 7.62352 6.14814 7.9815L4.04632 10.0833H17.9536L15.8518 7.9815C15.4938 7.62352 15.4938 7.04312 15.8518 6.68514C16.2098 6.32716 16.7902 6.32716 17.1481 6.68514L20.8148 10.3518C21.1728 10.7098 21.1728 11.2902 20.8148 11.6482L17.1481 15.3148C16.7902 15.6728 16.2098 15.6728 15.8518 15.3148C15.4938 14.9569 15.4938 14.3765 15.8518 14.0185L17.9536 11.9167H4.04632L6.14814 14.0185C6.50612 14.3765 6.50612 14.9569 6.14814 15.3148C5.79016 15.6728 5.20976 15.6728 4.85178 15.3148L1.18511 11.6482C0.827131 11.2902 0.827131 10.7098 1.18511 10.3518L4.85178 6.68514C5.20976 6.32716 5.79016 6.32716 6.14814 6.68514Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWidthIcon);
export default __webpack_public_path__ + "static/media/ArrowWidthIcon.ed0d6c0d3eb3c43b3b05ae9510781948.svg";
export { ForwardRef as ReactComponent };